import React, { useEffect, useState } from 'react'
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Snackbar, TextField, TextareaAutosize } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import { createHomework, deleteHomework, deleteHomeworkImage, getHomeworks, updateHomework } from '../actions/homework';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { useParams } from 'react-router-dom';
import './Homework.css'


let lastUpdatePromise = Promise.resolve();

function enqueueUpdate(taskFn) {
  // Chain the next task after the last one
  lastUpdatePromise = lastUpdatePromise.then(async () => {
    // Run the queued task
    await taskFn();
  });
  // Catch errors so the chain isn’t broken
  lastUpdatePromise.catch(() => {});
  return lastUpdatePromise;
}



const Homework = () => {



  const params = useParams()
  const { isLogin } = useSelector((state) => state.auth)
  const className = params.class

  const { homeworks } = useSelector((state) => state.homework)
  const dispatch = useDispatch()
  // const [open, setOpen] = useState(false);
  const [open, setOpen] = useState({});
  // const [selectedFile, setSelectedFile] = useState({})
  const [imageBase64, setImageBase64] = useState({});
  const [imageURL, setImageURL] = useState({});



  useEffect(() => {
    dispatch(getHomeworks(className))

  }, [className])








  const [components, setComponents] = useState(JSON.parse(JSON.stringify(homeworks)));

  useEffect(() => {
    setComponents(JSON.parse(JSON.stringify(homeworks)));
  }, [homeworks]);

  const [edit, setEdit] = useState()

  const [openSnackbar, setOpenSnackbar] = useState({});
  const handleSnackbarClose = (index) => {
    setOpenSnackbar({ ...openSnackbar, [index]: false });
  };
  const [openSnackbar0, setOpenSnackbar0] = useState({});
  const handleSnackbarClose0 = (index) => {
    setOpenSnackbar0({ ...openSnackbar0, [index]: false });
  };
  // const [openSnackbar1, setOpenSnackbar1] = useState({});
  // const handleSnackbarClose1 = (index) => {
  //   setOpenSnackbar1({ ...openSnackbar1, [index]: false });
  // };
  const [openSnackbar2, setOpenSnackbar2] = useState(false);
  const [openSnackbar3, setOpenSnackbar3] = useState(false);

  const addComponent = () => {
    dispatch(createHomework({ title: '', bodyText: '', note: '', className, bodyImages: [] }))
    setOpenSnackbar2(true)
    // setComponents([...components, { title: 'Sample Title 1', body: 'The body can be text or image or both', note: 'Sample Note' }]);
  };
  const deleteHomeworkButton = (_id) => {
    // console.log(components.filter((_,i)=>(i!==index)))
    // setComponents(components.filter((_, i) => (i !== index)));
    dispatch(deleteHomework(_id))
    setOpenSnackbar3(true)
  };

  const onDelete = (property, index) => {
    const homework = homeworks[index];
    if (!homework) return;
  
    const updatedHomework = {
      ...homework,
      [property]: "",
    };
  
    enqueueUpdate(() => onSave(updatedHomework, index));
  };
  
  
  const handleSave = (index, field, value) => {
    const homework = homeworks[index];
    if (!homework) return;
  
    const updatedHomework = {
      ...homework,
      [field]: value,
    };
  
    handleClose(index, field);
    enqueueUpdate(() => onSave(updatedHomework, index));
  };
  
  
  const handleFileSelect = async (event, index) => {
    const input = event.target;
    const files = event.target.files;
    if (!files || files.length === 0) return;
  
    const fileArray = Array.from(files);
  
    const base64DataArray = await Promise.all(
      fileArray.map(
        (file) =>
          new Promise((resolve) => {
            const imageURL = URL.createObjectURL(file);
            toDataURL(imageURL, (base64Data) => resolve(base64Data));
          })
      )
    );

        // addURL(index, imageURLs);
    // addBase64(index, base64DataArray);
  
    const homework = homeworks[index];
    if (!homework) return;
  
    const updatedHomework = {
      ...homework,
      bodyImages: [
        ...(homework.bodyImages || []),
        ...base64DataArray,
      ],
    };
  
    input.value = "";
    enqueueUpdate(() => onSave(updatedHomework, index));
  };
  
  
  const onSave = async (homework, index) => {
    // Always refetch the latest from Redux before saving
    const latest = homeworks.find((h) => h._id === homework._id) || homework;
    const merged = { ...latest, ...homework };
  console.log(homeworks[index])
    await dispatch(
      updateHomework(
        merged._id,
        merged,
        setOpenSnackbar,
        setOpenSnackbar0,
        index
      )
    );
  // setImageBase64([]);
    return Promise.resolve();
  };
  
  
  // dispatch(createHomework(homework))
    // alert('Body image edit in homework controller')
    // Title cannot be empty
    // classroom
    // handleSnackbarClose1(index)
    // console.log(components[index])
    // if (imageBase64[index] && imageBase64[index].length > 0) {
    //   clonedHomework.bodyImages = [
    //     ...(clonedHomework.bodyImages || []),
    //     ...imageBase64[index]
    //   ];
    // }
    
    // setImageBase64(prev => ({ ...prev, [index]: [] }));
    // console.log(clonedHomework)
    // console.log(components[index])
    // dispatch(updateHomework(homework._id, clonedHomework, setOpenSnackbar, setOpenSnackbar0, index)).then(() => {
      // After successfully updating, fetch the updated homeworks
      // dispatch(getHomeworks(className));
      // console.log("dddd");
      // setImageURL((prevImageURL) => ({
      //   ...prevImageURL,
      //   [index]: [],
      // }));
      // setImageBase64((prevImageBase64) => ({
      //   ...prevImageBase64,
      //   [index]: [],
      // }));
    // });
  // }


  // const handleOpen = (index) => {
  //   setOpen(open=>open.map((op,i)=> i===index?true:op));
  // };

  const handleOpen = (index, field) => {
    setOpen({ ...open, [index]: { ...open[index], [field]: true } });
  };

  const handleClose = (index, field) => {
    setOpen({ ...open, [index]: { ...open[index], [field]: false } });
  };
  // const addURL = (index, URL) => {
  //   setImageURL((prevImageURL) => ({
  //     ...prevImageURL,
  //     [index]: [...(prevImageURL[index] || []), ...URL],
  //   }));
  // };

  // const addBase64 = (index, base64) => {
  //   setImageBase64((prevImageBase64) => ({
  //     ...prevImageBase64,
  //     [index]: [...(prevImageBase64[index] || []), ...base64],
  //   }));
  // };





  const toDataURL = (url, callback) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

    // Step 3: Once all conversions are done, update state
    // addURL(index, imageURLs);
    // addBase64(index, base64DataArray);
  
    // Step 4: Save updated component
    // Optional: show snackbar, etc.
    // setOpenSnackbar1((openSnackbar) => ({ ...openSnackbar, [index]: true }));
  



  const handleImageDelete = (index, i) => {
    //There are images of 2 types
    // if (type === 'a')
      dispatch(deleteHomeworkImage(components[index]._id, components[index].bodyImages[i].public_id))
    // else {
    //   setImageBase64((prevImageBase64) => {
    //     const newImageBase64 = { ...prevImageBase64 };
    //     if (newImageBase64[index]) {
    //       newImageBase64[index].splice(i, 1);
    //     }
    //     return newImageBase64;
    //   });

    //   setImageURL((prevImageURL) => {
    //     const newImageURL = { ...prevImageURL };
    //     if (newImageURL[index]) {
    //       newImageURL[index].splice(i, 1);
    //     }
    //     return newImageURL;
    //   });

    // }
  }
  const formatDateString = (dateString) => {
    if (typeof dateString === 'string' && dateString.length >= 10) {
      const date = new Date(dateString);
      const options = { day: 'numeric', month: 'long', year: 'numeric' };
      return date.toLocaleDateString('en-GB', options);
    }
    return ''; // Invalid input, return null or handle the error as needed
  };

  // For expanded image modal
const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedImageUrl, setSelectedImageUrl] = useState('');

const openModal = (imageUrl) => {
  setSelectedImageUrl(imageUrl);
  setIsModalOpen(true);
};

const closeModal = () => {
  setIsModalOpen(false);
};

useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') closeModal();
  };
  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
}, []);



  return (
    homeworks.length > 0 ? <div className="container text-center">
      {isLogin && <Button size='small' style={{ margin: '10px' }} variant='contained' color={'secondary'} onClick={() => addComponent()}>
        Add Homework
      </Button>}
      {
        components.map(({ title, bodyText, note, _id, bodyImages, className, createdAt }, index) => (
          className === params.class && <div className="component" key={index}>
            <div className="component-header">
              <p style={{ marginBottom: '0px', fontWeight: 'bold' }}>{formatDateString(createdAt)}</p>
              <h3 className="font-weight-bold">{title}</h3>
              <Dialog open={open[index]?.title || false} onClose={() => handleClose(index, 'title')} fullWidth>
                <DialogTitle>New Title</DialogTitle>
                <DialogContent>
                  {/* <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label='Title'
                    type="text"
                    fullWidth
                    variant="standard"
                    value={edit}
                    onChange={(e) => setEdit(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        setEdit(prevEdit => prevEdit + '\n');
                      }}}
                  /> */}
                  <TextareaAutosize
                    autoFocus
                    minRows={1}
                    value={edit}
                    style={{ width: '100%', border: 'none', borderBottom: '1px solid black', resize: 'none' }}
                    onChange={(e) => setEdit(e.target.value)}
                  />

                </DialogContent>
                <DialogActions>
                  <Button onClick={() => {handleSave(index, 'title', edit )}}>Save</Button>
                  <Button onClick={() => handleClose(index, 'title')}>Cancel</Button>
                </DialogActions>
              </Dialog>
              {isLogin && <>
                <Button size='small' style={{ margin: '10px' }} variant='contained' color={'primary'} onClick={() => { setEdit(title); handleOpen(index, 'title') }}>
                  {title ? "Edit Title": "Add Title"}
                </Button>
                {title && <Button size='small' style={{ margin: '10px' }} variant='contained' color={'warning'} onClick={() => onDelete('title', index)}>
                  Delete title
                </Button>}
              </>
              }
            </div>
            <div className="component-body">
              <Dialog open={open[index]?.bodyText || false} onClose={() => handleClose(index, 'bodyText')} fullWidth>
                <DialogTitle>New Body</DialogTitle>
                <DialogContent>
                  {/* <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label='Body'
                    type="text"
                    fullWidth
                    variant="standard"
                    value={edit}
                    onChange={(e) => setEdit(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        setEdit(prevEdit => prevEdit + '\n');
                      }}}
                  /> */}
                  <TextareaAutosize
                    autoFocus
                    minRows={1}
                    value={edit}
                    onChange={(e) => setEdit(e.target.value)}
                    style={{ width: '100%', border: 'none', borderBottom: '1px solid black', resize: 'none' }}

                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        setEdit(prevEdit => prevEdit + '\n');
                      }
                    }}
                  />

                </DialogContent>
                <DialogActions>
                  <Button onClick={() => handleSave(index, 'bodyText', edit)}>Save</Button>
                  <Button onClick={() => handleClose(index, 'bodyText')}>Cancel</Button>
                </DialogActions>
              </Dialog>
              <div
  className='flexDiv'
  style={{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  }}
>
  {bodyImages?.map((image, i) => (
    <div key={i} style={{ position: 'relative', margin: '10px' }}>
      <img
        style={{
          maxWidth: '100%',
          maxHeight: '200px',
          cursor: 'pointer',
          borderRadius: '6px',
          transition: 'transform 0.2s ease',
        }}
        src={image.url}
        alt=""
        onClick={() => openModal(image.url)}
        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      />
      {isLogin && (
        <IconButton
          color="error"
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            backgroundColor: 'rgba(255,255,255,0.7)',
            borderRadius: 0,
          }}
          onClick={() => handleImageDelete(index, i, 'a')}
        >
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  ))}

  {/* Fullscreen Modal Overlay */}
  {isModalOpen && (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
      onClick={closeModal}
    >
      <img
        src={selectedImageUrl}
        alt=""
        style={{
          maxWidth: '90%',
          maxHeight: '90%',
          borderRadius: '10px',
          objectFit: 'contain',
          boxShadow: '0 0 10px rgba(0,0,0,0.4)',
        }}
      />
    </div>
  )}
</div>

              {/* <div className='flexDiv' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}> */}
                {/* {imageBase64[index]?.map((url, i) => (
                  <div key={url}  >
                    <img style={{ maxWidth: '100%', maxHeight: '200px', margin: '10px' }} src={url} alt={''} />
                    {isLogin && <IconButton color="error" sx={{ borderRadius: 0 }} onClick={() => handleImageDelete(index, i, 'b')}> <DeleteIcon /> </IconButton>}
                  </div>
                ))
                } */}
              {/* </div> */}
              <p className="h5">
                {bodyText?.split('\n').map((text, index) => (
                  <React.Fragment key={index}>
                    {text}
                    <br />
                  </React.Fragment>
                ))}
              </p>

              {isLogin && <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start' }}>
                <div>
                  <input
                    type="file"
                    accept="image/*" // Accept only image files
                    style={{ display: 'none' }}
                    id={`image-upload-${index}`}
                    onChange={(e) => { handleFileSelect(e, index) }}
                    multiple
                  />
                  <label htmlFor={`image-upload-${index}`}>
                    <Button
                      size="small" // Set the size to 'small'
                      style={{ margin: '10px' }}
                      variant="contained"
                      component="span"
                      startIcon={<CloudUploadIcon />} // Icon for the button
                    >
                      Upload Image
                    </Button>
                  </label>
                </div>
                <Button size='small' style={{ margin: '10px' }} variant='contained' color={'primary'} onClick={() => { setEdit(bodyText); handleOpen(index, 'bodyText') }}>
                  {bodyText ? "Edit Text" : "Add text"}
                </Button>
                {bodyText && <Button size='small' style={{ margin: '10px' }} variant='contained' color={'warning'} onClick={() => onDelete('bodyText', index)}>
                  Delete text
                </Button>}
              </div>}
            </div>
            <div className="component-footer">
              <p style={{ color: 'red' }}>{note}</p>
              <Dialog open={open[index]?.note || false} onClose={() => handleClose(index, 'note')} fullWidth>
                <DialogTitle>New Note</DialogTitle>
                <DialogContent>
                  {/* <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label='Note'
                    type="text"
                    fullWidth
                    variant="standard"
                    value={edit}
                    onChange={(e) => setEdit(e.target.value)}
                  /> */}
                  <TextareaAutosize
                    autoFocus
                    minRows={1}
                    value={edit}
                    onChange={(e) => setEdit(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        setEdit(prevEdit => prevEdit + '\n');
                      }
                    }}
                    style={{ width: '100%', border: 'none', borderBottom: '1px solid black', resize: 'none' }}
                  />

                </DialogContent>
                <DialogActions>
                  <Button onClick={() => handleSave(index, 'note', edit)}>Save</Button>
                  <Button onClick={() => handleClose(index, 'note')}>Cancel</Button>
                </DialogActions>
              </Dialog>
              {isLogin && <>
                <Button size='small' style={{ margin: '10px' }} variant='contained' color={'primary'} onClick={() => { setEdit(note); handleOpen(index, 'note') }}>
                  {note ? "Edit Note" : "Add Note"}
                </Button>
                {note && <Button size='small' style={{ margin: '10px' }} variant='contained' color={'warning'} onClick={() => onDelete('note', index)}>
                  Delete Note
                </Button>}
              </>
              }
            </div>
            {isLogin && <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: "center" }}>
              {/* <Button size='small' style={{ margin: '10px' }} variant='contained' color='success' onClick={() => onSave(components[index], index)}>
                Save
              </Button> */}
              <Snackbar open={openSnackbar[index] || false} autoHideDuration={5000} onClose={() => handleSnackbarClose(index)}>
                <Alert onClose={() => handleSnackbarClose(index)} severity="success" sx={{ width: '100%' }}>
                  Homework updated
                </Alert>
              </Snackbar>
              <Snackbar open={openSnackbar0[index] || false} autoHideDuration={null} onClose={() => handleSnackbarClose0(index)}>
                <Alert onClose={() => handleSnackbarClose0(index)} severity="info" sx={{ width: '100%' }}>
                  Updating Homework...
                </Alert>
              </Snackbar>
              {/* <Snackbar open={openSnackbar1[index] || false} autoHideDuration={null} onClose={() => handleSnackbarClose1(index)}>
                <Alert onClose={() => handleSnackbarClose1(index)} severity="info" sx={{ width: '100%' }}>
                  Homework is being edited
                </Alert>
              </Snackbar> */}
              <Snackbar open={openSnackbar2 || false} autoHideDuration={5000} onClose={() => setOpenSnackbar2(false)}>
                <Alert onClose={() => setOpenSnackbar2(false)} severity="success" sx={{ width: '100%' }}>
                  Homework is created
                </Alert>
              </Snackbar>
              <Snackbar open={openSnackbar3 || false} autoHideDuration={5000} onClose={() => setOpenSnackbar3(false)}>
                <Alert onClose={() => setOpenSnackbar3(false)} severity="error" sx={{ width: '100%' }}>
                  Homework is Deleted
                </Alert>
              </Snackbar>
              <Button size='small' style={{ margin: '10px' }} variant='contained' color={'warning'} onClick={() => deleteHomeworkButton(_id)}>
                Delete Homework
              </Button>
            </div>}
          </div>
        ))}
    </div> : <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '80vh', // 80% of the viewport height
        }}
      >
        <div
          style={{
            textAlign: 'center',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          <div
            style={{
              fontSize: '24px',
              fontWeight: 'bold',
              marginBottom: '20px',
            }}
          >
            No Homework
          </div>
          {isLogin && <Button size='small' style={{ margin: '10px' }} variant='contained' color={'secondary'} onClick={() => addComponent()}>
        Add Homework
      </Button>}
        </div>
      </div>
    </>
  );
}

export default Homework
